import styled from "@emotion/styled";
import { COLOR_WHITE_20 } from "shared/theme/colors";

export const SkeletonContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
`;

const BaseSkeleton = styled("div")`
  background-color: ${COLOR_WHITE_20};
  border-radius: 100px;
`;

export const ColoredSkeletonCard = styled("div")`
  width: 161px;
  height: 77px;
  background-color: rgba(33, 38, 77, 1);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`;

export const SportSkeleton = styled(BaseSkeleton)`
  width: 64px;
  height: 8px;
`;

export const BadgeSkeleton = styled(BaseSkeleton)`
  width: 24px;
  height: 8px;
`;

export const TeamSkeleton = styled(BaseSkeleton)`
  width: 68px;
  height: 8px;
`;

export const CenterSkeleton = styled(BaseSkeleton)`
  width: 13px;
  height: 13px;
  border-radius: 50%;
`;

export const CoefficientSkeleton = styled(BaseSkeleton)`
  width: 49px;
  height: 17px;
`;
